<p class="mk-muted" *ngIf="store.loadingRematch">Loading&hellip;</p>
<p class="fx-error" role="alert" *ngIf="store.rematchLoadError">Couldn't load the records. Close this and try again.</p>

<div class="mk-card fx" *ngFor="let row of store.rematchRows; trackBy: trackRow" [class.done]="row.added">
  <div class="fx-pair">
    <div class="fx-side">
      <span class="tag">In Sage</span>
      <b>{{ row.sageName }}</b>
      <span class="mk-muted">{{ row.sageCode }}<ng-container *ngIf="row.sageCode && row.sageKind"> &middot; </ng-container>{{ row.sageKind }}</span>
    </div>
    <div class="fx-side">
      <span class="tag">Matched in Aivor to</span>
      <b>{{ row.aivorName }}</b>
      <span class="mk-muted">{{ row.aivorCode }}<ng-container *ngIf="row.aivorCode && row.aivorKind"> &middot; </ng-container>{{ row.aivorKind }}</span>
    </div>
  </div>
  <p class="mk-muted fx-detail">{{ row.record.detail }}</p>

  <div class="fx-status ok" *ngIf="row.added">
    <i class="bi bi-check-lg" aria-hidden="true"></i><span>Added to Aivor as new</span>
  </div>

  <ng-container *ngIf="!row.added">
    <p class="mk-muted" *ngIf="!row.match && !store.loadingRematch">This record isn't waiting in a review any more.</p>
    <div class="fx-actions" *ngIf="row.match">
      <button
        type="button"
        class="btn-teal-gradient fx-use"
        *ngIf="row.canAddAsNew"
        [disabled]="row.saving || !syncEnabled"
        (click)="store.addAsNew(row)"
      >
        {{ row.saving ? 'Adding…' : 'Add it to Aivor as new' }}
      </button>
      <button type="button" class="link-btn" (click)="openMatching.emit(row.type)">Pick another match</button>
    </div>
    <p class="fx-error" role="alert" *ngIf="row.error">{{ row.error }}</p>
  </ng-container>
</div>
